import { useEffect, useState } from "react";

import { Dropdown } from "react-bootstrap";
import MainPagetitle from "../../../layouts/MainPagetitle";
import RestructureLoanSearch from "./RestructureLoanSearch/RestructureLoanSearch";

const RestructureLoan = (props) => {
  const { role } = props?.$store?.user;
  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
  });
  const [tableData, setTableData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);

  const [rowcount, setRowcount] = useState(0);
  const [columns, setColumns] = useState([
    {
      dataIndex: "customer",
      title: "Name",
      render: (text, record) => {
        return (
          <div>
            <h6 className="text-primary">
              {record?.loanAccount?.borrowerName}
            </h6>
            <span>{record.applicationId}</span>
          </div>
        );
      },
    },
    {
      dataIndex: "loanAccountNumber",
      title: "LAN",
    },
    // {
    //   dataIndex: "outstandingAmount",
    //   title: "Outstanding",
    // },
    // {
    //   dataIndex: "overdue",
    //   title: "Overdue",
    // },
    {
      dataIndex: "restructureWaiver",
      title: "Waiver",
    },
    {
      dataIndex: "sanctionedLoanAmt",
      title: "New Loan Amt",
      render: (text) => {
        return <>{text?.cur()}</>;
      },
    },
    {
      dataIndex: "restructureIRR",
      title: "ROI",
    },
    {
      dataIndex: "restructureTenure",
      title: "Tenure",
    },
    {
      dataIndex: "restructureLoanStartDate",
      title: "New Loan Start Date",
      render: (text, record) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        return date;
      },
    },
    {
      dataIndex: "restructureLoanEndDate",
      title: "New Loan End Date",
      render: (text, record) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        return date;
      },
    },
    {
      dataIndex: "remarks",
      title: "Admin Remarks",
    },
    {
      dataIndex: "status",
      title: "Application Status",
      render: (text, record) => {
        let mappedStatus =
          _enum.STATUS_COLOR_MAP[record?.application?.status?.toLowerCase()] ||
          "";
        return (
          <Dropdown className="status-dropdown no-arrow pe-none">
            <Dropdown.Toggle as="div" className={mappedStatus}>
              <span>{record?.application?.status.toTitleCase()}</span>
              <i class="fa-solid fa-chevron-down ms-2"></i>
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
  ]);

  const onPageChange = (pageData) => {
    // console.log({ onPageChange: pageData });
    setSearch({
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 25,
    });
  };

  const getApplications = (params) => {
    let payload = {
      ...params,
    };
    console.log({ payload });
    props.apis
      .apiGetPendingLoanRestructureRequests(payload)
      .then(({ data, total }) => {
        setTableData(data);
        setIsFetching(false);
        setRowcount(total);
      });
  };

  const GetToSelfApplication = (record) => {
    // setEditmode(true);
    // setViewmode(false);
    // GET APPLICATION BY ID
    props.apis
      .apiUnderwriterSelfAssignApplication({
        applicationNumber: record.applicationId,
      })
      .then((data) => {
        swal2.fire({
          title: "Application self-assigned successfully.",
          icon: "success",
          iconColor: "#FF4D4D",
          timer: 4000,
        });
        getApplications();
      })
      .catch((e) => {});
  };

  const onSearch = (data, reset) => {
    console.log("onSearch on leads", data, reset);
    if (Object.keys(data).length > 0) {
      let defaultSearchData = Object.only(data, ["limit", "page"]);
      let payload;
      if (reset) {
        payload = {
          ...defaultSearchData,
        };
      } else {
        payload = {
          ...data,
          page: 1,
          limit: 10,
        };
      }
      console.log({ payload });
      setSearch(payload);
    }
  };

  useEffect(() => {
    let payload = {
      ...search,
    };
    console.log({ payload, search });

    getApplications(payload);
  }, [search]);

  props.$setNode({
    props,
  });
  return (
    <>
      <MainPagetitle
        mainTitle="Pending Applications"
        parentTitle={"Home"}
        pageIcon={imagepaths.applicationCheckActiveImg}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card border-0">
              <div className="card-body p-0">
                <div className="tbl-caption-container justify-content-end">
                  <RestructureLoanSearch
                    onSearch={(...arg) => onSearch(...arg)}
                  />
                </div>
                <AppTable
                  data={tableData}
                  columns={columns}
                  onChange={(...arg) => onPageChange(...arg)}
                  total={rowcount}
                  reorder={true}
                  editAction={(e) => GetToSelfApplication(e)}
                  editActionText="Get to self"
                  viewable={false}
                  deletable={false}
                  loading={isFetching}
                ></AppTable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default constore(RestructureLoan);
